import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import BotonAsignar from './BotonAsignar.jsx';
import BotonDesAsignar from './BotonDesAsignar.jsx';

const HeaderButtons = (props) => {
    if (props.tipoOperacion == 1) {
        return (
            <div className="col-md-3">
                <BotonAsignar usuariosFiltrados={props.usuariosFiltrados} asignarPerfil={props.asignarPerfil} />
            </div>
        );
    } else {
        return (
            <div className="col-md-3">
                <BotonDesAsignar usuariosFiltrados={props.usuariosFiltrados} desasignarPerfil={props.desasignarPerfil} />
            </div>
            
        );
    }
    
}
export default HeaderButtons;